export type AccountPortal = 'tenant' | 'vendor' | 'platform';

/**
 * Where each portal keeps the signed-in person's own pages (PREP §1.8). The
 * supplier has no sign-in security page until a supplier password contract
 * exists (BC-A4); suppliers have no MFA.
 */
export const ACCOUNT_ROUTES = {
  tenant: { profile: '/account/profile', security: '/account/security' },
  vendor: { profile: '/vendor/account', security: null },
  platform: { profile: '/platform/account', security: '/platform/security' },
} as const satisfies Record<AccountPortal, { profile: string; security: string | null }>;
